import { VerificationTransactionSummary } from "@idw-types/data/reports";
import { useEffect, useState } from "react";
import { DEFAULT_HIGHCHARTS_PIE_CHART_OPTIONS } from "@constants/highcharts";
import { HighchartsChartContainer } from "../../../common/highcharts-chart-container/highcharts-chart-container";
import merge from "lodash/merge";
import { resources } from "@constants/hardcoded-strings";
import { APPROVED_COLOR, DENIED_COLOR, NO_DECISION_COLOR, OBLIGATION_COLOR } from "@constants/colors";

type VerificationTransactionsSummaryPieChartProps = {
    data: VerificationTransactionSummary;
};

export const VerificationTransactionsSummaryPieChart = (props: VerificationTransactionsSummaryPieChartProps) => {
    const { data } = props;

    const createSeriesData = (data: VerificationTransactionSummary) => {
        return  [
            {
                name: resources.charts.verificationTransactionsSummary.labels.approved,
                color: APPROVED_COLOR,
                y: data.policyApprovalCount
            },
            {
                name: resources.charts.verificationTransactionsSummary.labels.denied,
                color: DENIED_COLOR,
                y: data.policyRejectionCount
            },
            {
                name: resources.charts.verificationTransactionsSummary.labels.noDecision,
                color: NO_DECISION_COLOR,
                y: data.policyNoDecisionCount
            },
            {
                name: resources.charts.verificationTransactionsSummary.labels.obligations,
                color: OBLIGATION_COLOR,
                y: data.policyObligationCount
            }
        ];
    };

    const [chartOptions, setChartOptions] = useState<Highcharts.Options>(merge({}, DEFAULT_HIGHCHARTS_PIE_CHART_OPTIONS, {
        chart: {
            width: "250",
            height: "150"
        },
        legend: {
            align: "center",
            itemDistance: 7,
            layout: "horizontal",
            title: {
                text: ''
            },
            verticalAlign: "bottom",
        },
        plotOptions: {
            pie: {
                size: "80",
                showInLegend: true,
                dataLabels: {
                    enabled: false
                }
            }
        },
        series: [{
            data: createSeriesData(data)
        }]
    }));

    useEffect(() => {
        const newChartOptions: Highcharts.Options = merge({}, chartOptions, {
            series: [{
                data: createSeriesData(data)
            }]
        });

        setChartOptions(newChartOptions);

    }, [data]);

    return (
        <HighchartsChartContainer options={chartOptions} />
    );
};